import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { useNavigate, useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import { Row, Col, Form, Input, Label, Button, CardText, CardTitle, FormFeedback, UncontrolledTooltip } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API, setAuthToken } from "../../config/api";
import { FaUser, FaUserMd, FaGenderless, FaMailBulk, FaTransgender, FaPhone, FaAddressBook, FaAddressCard, FaEdit, FaTrash, FaSave, FaPlus, FaSearch, FaUserAlt, FaAccessibleIcon, FaCriticalRole, FaUserClock, FaUserCheck, FaAccusoft, FaArchive, FaBackspace, FaBackward, FaArrowCircleLeft, FaRegArrowAltCircleLeft, FaEyeDropper, FaRegEye, FaMehRollingEyes, FaBullseye, FaStreetView, FaEye, FaPerbyte, FaAngleUp, FaAdjust, FaMizuni, FaCreativeCommonsZero, FaCreativeCommons, FaAward, FaStethoscope, FaListOl, FaDAndD, FaDailymotion, FaGasPump, FaDesktop, FaFileMedical, FaBookMedical, FaCalendar, FaCalendarDay, FaCalendarAlt, FaTransgenderAlt, FaBirthdayCake, FaCalendarCheck, FaPhoenixFramework, FaPhoneAlt, FaPhoneSlash, FaMobile, FaMobileAlt, FaMarsStroke, FaWpforms, FaSync, FaUserPlus, FaTag, FaRegEdit, FaUserEdit, FaMedkit, FaNotesMedical, FaUndo, FaArrowLeft, FaUndoAlt, FaArrowAltCircleLeft } from 'react-icons/fa'
import ReactPaginate from "react-paginate";
import Modal from 'react-bootstrap/Modal';
import logo_side from "../../assets/signature/logo-side-detail.png"
import Logo_Signature from "../../assets/signature/signatureNewIcon.png"
import Logo_Batik from "../../assets/signature/logo-batik.png"
import "bulma/css/bulma.css";
import { useMutation } from "react-query";
import "../../index.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
// Modal Role
import ModalAddMedis from "./ModalPhysicalCheck/ModalAdd"
import ModalUpdateMedis from "./ModalPhysicalCheck/ModalUpdate"
import { ScaleLoader } from "react-spinners";
import LoaderHome from "../Loader/LoaderHome"
import WellcomeCard from "../Admin/Components/Wellcome";
import HeaderReusable from "../Global/HeaderContent";
import { SettingGeneralProvider } from "../../context/settingGeneralContext";
import TableReusable from "../Global/Table";

export default function Login() {
  // let navigate = useNavigate();
  // useEffect(() => {
  //   if (localStorage.getItem("token") == null || undefined) {
  //       navigate("/");
  //     }
  // }, []);
  document.title = "SDC Apps";
  const navigate = useNavigate()
  const [getData, setGetData] = useState([]);
  const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);
  const [getDataRekamMedis, setGetDataRekamMedis] = useState([]);
  const [pagination, setPagination] = useState([])
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState();
  const [ascending, setAscending] = useState(0);
  const [rows, setRows] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("token");
  const [idDelete, setIdDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("")
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [dataMap, setDataMap] = useState("");
  const [dataSearch, setDataSearch] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  // Responsive to mobile or dekstop
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 1224px)' })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  // modal role add 
  const [idModal, setIdModalUpdate] = useState();
  const [idModalAdd, setIdModalAdd] = useState();
  const { id } = useParams()
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [loading, setLoading] = useState(false);


  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };

  const GetResponseData = async () => {
    setLoading(true)
    const response = await API.get(`emr-service/phy-checks?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&search=${search}&id_patient=${id}`, fetchParams)
    if (response.data.data.length !== 0) {
      setGetData(response.data.data)
      setGetDataRekamMedis(response.data.data[0].patient_data)
      setPage(response.data.pagination.current_page);
      setPages(response.data.pagination.total_pages);
      setRows(response.data.pagination.total);
    }
    setLoading(false)
  }

  const GetResponseDataProfile = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.get(`user-service/auth/profile`, fetchParams)
      // Checking process
      if (response?.status === 200) {
        setGetDataProfileDetail(response.data.data.user_detail)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  useEffect(() => {
    GetResponseDataProfile()
    GetResponseData()
  }, [])

  const deleteById = async (id) => {
    Swal.fire({
      title: 'Apakah Kamu Yakin?',
      text: `Menghapus data ini`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await API.delete(`emr-service/phy-checks/${id}`, fetchParams);
        if (response.data.error == false) {
          GetResponseData()
          swal({
            title: 'Success',
            text: "Your data has been successfully deleted",
            icon: 'success',
            timer: 3000,
            buttons: false
          });
        }
      }
    })
  };

  const changePage = ({ selected }) => {
    setPage(selected + 1);
    if (selected === 10) {
      setMsg(
        ""
      );
    } else {
      setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };

  const navigateHome = () => {
    navigate('/patients');
  }

  const buttonRefresh = () => {
    window.location.reload();
  }

  const viewModalAdd = () => {
    setIdModalAdd(id)
    setModalAdd(true)
  }

  const viewModalUpdate = (id) => {
    setModalUpdate(true)
    setIdModalUpdate(id)
  }

  const getRowNumber = (index) => (page - 1) * 10 + index + 1;


  return (
    <>
      <Row>
        <WellcomeCard
          getDataProfileNull={getDataProfileDetail === null}
          getDataProfileFirstName={getDataProfileDetail?.firstname}
          getDataProfileLastName={getDataProfileDetail?.lastname}
        />
      </Row>
      <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
        {modalAdd && <ModalAddMedis GetResponseData={GetResponseData} idModalAdd={idModalAdd} show={modalAdd} onHide={() => setModalAdd(false)} />}
        {modalUpdate && <ModalUpdateMedis GetResponseData={GetResponseData} idModal={idModal} show={modalUpdate} onHide={() => setModalUpdate(false)} />}
        {loading && <LoaderHome />}

        <SettingGeneralProvider>
          <HeaderReusable
            title="Physical Check"
            icon={FaAddressBook}
            isTabletOrMobile={false}
            query={query}
            setQuery={setQuery}
            searchData={searchData}
            onAdd={viewModalAdd}
            onRefresh={buttonRefresh}
            showAddButton={false}
            showRefreshButton={true}
            showCustomButtonBack={true}
          />
        </SettingGeneralProvider>

        <Col xl='12' sm='12'>
          <div>
            <div style={{ display: "block", height: "100%", overflowY: "auto", overflowX: "auto" }}>
              <div >
                <SettingGeneralProvider>
                  <TableReusable
                    columns={[
                      { key: "no", label: "No", render: (_, index) => getRowNumber(index) },
                      {
                        key: "date_check", label: "Waktu Perawatan",
                        render: (row) => {
                          const [year, month, day] = row.date_check.split('-');
                          const monthNames = [
                            "Januari", "Februari", "Maret", "April", "Mei", "Juni",
                            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
                          ];
                          return `${day} ${monthNames[parseInt(month, 10) - 1]} ${year}`;
                        }
                      },
                      { key: "height", label: "Tinggi Badan " },
                      { key: "weight", label: "Berat Badan " },
                      { key: "blood_type", label: "Golongan Darah " },
                      { key: "body_temperature", label: "Suhu Tubuh " },
                      { key: "blood_pressure", label: "Tekanan Darah " },
                      {
                        key: "create_by_data",
                        label: "Dibuat Oleh",
                        render: (row) => (
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <img
                              src={row.create_by_data?.photo_profile}
                              alt="Profile"
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                border: "2px solid #6C85FF",
                                objectFit: "cover"
                              }}
                            />
                            <span style={{ marginLeft: "5px" }}>
                              {row.create_by_data?.username || "Unknown"}
                            </span>
                          </div>
                        )
                      },
                      {
                        key: "action",
                        label: "Setup",
                        render: (user) => (
                          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                            <button
                              onClick={() => viewModalUpdate(user?.id, user?.name, user?.code, user?.type, user?.price, user?.description)}
                              style={{
                                fontSize: "12px",
                                color: "white",
                                backgroundColor: "#ff9933",
                                padding: "5px 5px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                border: "none",
                                display: "flex"
                              }}>
                              <FaEdit />
                            </button>
                            <button
                              onClick={() => deleteById(user?.id)}
                              style={{
                                fontSize: "12px",
                                color: "white",
                                backgroundColor: "#B60000",
                                padding: "5px 5px",
                                borderRadius: "3px",
                                cursor: "pointer",
                                border: "none",
                                display: "flex"
                              }}>
                              <FaTrash />
                            </button>
                          </div>
                        ),
                      },
                    ]}
                    data={getData}
                    rows={rows}
                    page={page}
                    pages={pages}
                    changePage={changePage}
                    msg={msg}
                  />
                </SettingGeneralProvider>

              </div>
            </div>
          </div>
        </Col>

      </div>
    </>
  );
}
